/**
 * Sourced from https://gist.github.com/atomiks/520f4b0c7b537202a23a3059d4eec908
 */

// Will only render the `content` or `render` elements if the tippy is mounted to the DOM.
// Replace <Tippy /> with <LazyTippy /> component and it should work the same.

import React, { ReactElement } from 'react';
import Tippy, { TippyProps } from '@tippyjs/react/headless';

// Export own set of props (even if they are the same for now) to enable clients to be more future-proof
type LazyTippyProps = TippyProps;

export const LazyTippy = (props: LazyTippyProps): ReactElement => {
  const [mounted, setMounted] = React.useState(false);

  const lazyPlugin = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    fn: () => ({
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      onMount: () => setMounted(true),
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      onHidden: () => setMounted(false),
    }),
  };

  const computedProps = { ...props };

  computedProps.plugins = [lazyPlugin, ...(props.plugins || [])];

  if (props.render) {
    const render = props.render; // let TypeScript safely derive that render is not undefined
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    computedProps.render = (...args) => (mounted ? render(...args) : '');
  } else {
    computedProps.content = mounted ? props.content : '';
  }

  return <Tippy {...computedProps} />;
};
